import React, { useState, useEffect } from 'react';
import eveImg from '../images/eveimg.jpg';
import eveImg2 from '../images/eveimg2.jpg';
import { IoArrowUpCircleOutline } from "react-icons/io5";
import { format } from 'date-fns';


import YouTube from 'react-youtube';
import { useParams } from 'react-router-dom';

export default function EventsDetail() {

  const { id } = useParams();
  const [eventDtlData, seteventDtlData] = useState({});

  const videoId = '1XlXVmH5eK4?si=FGkKnPiCCGMcfvaz';

  const eventDtlByID = () => {
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch(`https://api.padampura.com/Events_ByID?MainID=${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true) {
          // console.log(result);
          seteventDtlData(result.data);
        }
      })
      .catch((error) => console.error(error));
  }

  useEffect(() => {
    eventDtlByID();
    scrollToTop();
  }, [])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <div className='mt-3' >
      <div style={{ backgroundImage: `url(${eveImg2})`, width: "100%", backgroundPosition: "center", backgroundSize: "cover", objectFit: "cover", borderRadius: 5 }} >
        <div style={{ background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5), #fff 80vh)", position: "relative", height: "100%", borderRadius: 5 }} >
          <div className='container'>
            <div className='row p-5'>
              <div className='col-lg-12 col-md-8 col-sm-12 m-auto py-5'>
                <div className='card bg-transparent border-0 text-center my-5'>
                  <div class="div-content py-4">
                    <p className='' style={{ fontFamily: 'Poppins', fontSize: "3em", color: '#fff', fontWeight: 400 }} >{eventDtlData?.Ev_Name}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='container my-5'>
        <div className='row'>
          <div className='col-lg-4 col-md-6 col-sm-12'>
            <div className="card rounded-0 border-0" style={{ width: '100%' }}>
              <img src={eveImg} className="" alt="..." style={{ width: '100%' }} />
            </div>
          </div>
          {/* <div className='col-lg-1'></div> */}
          <div className='col-lg-8 col-md-6 col-sm-12'>
            <div className="card rounded-0 border-0" style={{ width: '100%' }}>
              <div className='pt-1'>
                <p style={{ fontSize: 14, fontFamily: "Poppins", fontWeight: 400, lineHeight: 1.5 }}>{eventDtlData?.Ev_LongDesc}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='container mb-5'>
        <div className='row'>
          <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
            <div className="card rounded-1 border-0 p-3 evnt-full-dtl">
              <p style={{ fontSize: 24, fontFamily: "Poppins", fontWeight: 500, letterSpacing: 1, lineHeight: 1.5 }}>Details</p>
              <p style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 500, letterSpacing: 1, lineHeight: 1.5 }}>Start Date:</p>
              <p style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 500, letterSpacing: 1, lineHeight: 1.5 }}>{eventDtlData?.Ev_StartDate}</p>
              <p style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 500, letterSpacing: 1, lineHeight: 1.5 }}>End Date:</p>
              <p style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 500, letterSpacing: 1, lineHeight: 1.5 }}>{eventDtlData?.Ev_EndDate}</p>
            </div>
          </div>
          <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
            <div className="card rounded-1 border-0 p-3 evnt-full-dtl">
              <div style={{ fontSize: 14, fontFamily: "Poppins", fontWeight: 600, letterSpacing: 1, lineHeight: 1.9 }}>Organize By:</div>
              <div style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 500, letterSpacing: 1, lineHeight: 1.9 }}>{eventDtlData?.Ev_Organiser}</div>
              <div style={{ fontSize: 14, fontFamily: "Poppins", fontWeight: 600, letterSpacing: 1, lineHeight: 1.9 }}>Sponsers</div>
              <div style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 500, letterSpacing: 1, lineHeight: 1.9 }}>{eventDtlData?.Ev_Sponsers}</div>
              <div style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 600, letterSpacing: 1, lineHeight: 1.9 }}>Phone:</div>
              <div style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 500, letterSpacing: 1, lineHeight: 1.9 }}>+91 1232524514</div>
              <div style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 600, letterSpacing: 1, lineHeight: 1.9 }}>Email:</div>
              <div style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 500, letterSpacing: 1, lineHeight: 1.9 }}>Yoursite@example.com</div>
            </div>
          </div>
          <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
            <div className="card rounded-1 border-0 p-3 evnt-full-dtl">
              <p style={{ fontSize: 24, fontFamily: "Poppins", fontWeight: 400, letterSpacing: 1, lineHeight: 1.5 }}>Venus</p>
              <p style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 400, letterSpacing: 1, lineHeight: 1.5 }}>Padampura, Bada</p>
              <p style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 400, letterSpacing: 1, lineHeight: 1.5 }}>Tehsil, Chaksu</p>
              <p style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 400, letterSpacing: 1, lineHeight: 1.5 }}>District, jaipur</p>
              <p style={{ fontSize: 12, fontFamily: "Poppins", fontWeight: 400, letterSpacing: 1, lineHeight: 1.5 }}>Rajasthan, India</p>
            </div>
          </div>
          <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
            <div className="card rounded-1 border-0">
              <div style={{ width: '100%', height: '215px' }}>
                <iframe
                  title="Google Map"
                  width="100%"
                  height="100%"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3563.73239400511!2d75.91925277449764!3d26.720994868305045!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396dc53071f2920b%3A0x72a52e0294847887!2sBada%20padampura%20jain%20temple!5e0!3m2!1sen!2sin!4v1714049424665!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='container mb-5'>
        <p className='text-center my-5' style={{ fontFamily: "Poppins", fontSize: "1.5em", color: "#1f5156", fontWeight: 600 }} >EVENT HIHGLIGHT'S</p>
        <div className='row'>
          <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
            <div className="card rounded-0 border-0" style={{ width: '100%' }}>
              <img src={eveImg} className="evntDtl-img" alt="..." style={{ width: '100%' }} />
            </div>
          </div>
          <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
            <div className="card rounded-0 border-0" style={{ width: '100%' }}>
              <img src={eveImg} className="evntDtl-img" alt="..." style={{ width: '100%' }} />
            </div>
          </div>
          <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
            <div className="card rounded-0 border-0" style={{ width: '100%' }}>
              <img src={eveImg} className="evntDtl-img" alt="..." style={{ width: '100%' }} />
            </div>
          </div>
          <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
            <div className="card rounded-0 border-0" style={{ width: '100%' }}>
              <div className='' style={{ width: "100%" }}>
                <iframe
                  width="100%"
                  height="195"
                  src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                  title="YouTube Video"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <button className="scroll-to-top-button border-0 rounded-2" onClick={scrollToTop} style={{ width: 40, height: 40, backgroundColor: "red", color: "#fff", alignItems: "center", justifyContent: "center", display: "flex" }}><IoArrowUpCircleOutline style={{ fontSize: 40 }} /></button>
    </div>
  )
}
